export function timeElapsed(date: Date, now: Date = new Date()): string {
    
    let diff = Math.floor((now.getTime() - date.getTime()) / 1000); // total em segundos

    const days = Math.floor(diff / (60 * 60 * 24));
    diff %= 60 * 60 * 24;

    const hours = Math.floor(diff / (60 * 60));
    diff %= 60 * 60;

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;

    const pad = (n: number) => String(n).padStart(2, "0");

    if (days > 0) {
        return `${days}d ${pad(hours)}h ${pad(minutes)}min ${pad(seconds)}s`;
    }
    return `${pad(hours)}h ${pad(minutes)}min ${pad(seconds)}s`;
  }